import { React, Component } from "react";

import { Grid, Paper, Typography, Box } from "@material-ui/core";
import Button from "@mui/material/Button";
import GraphWrapper from "../../../utility/ChartWrapper.js";
import { ButtonGroup, Input, Form, FormGroup, Label } from "reactstrap";
import moment from "moment";
import Slider from "../../../widgets/Slider.js";
import { connect } from "react-redux";
import { setPwrGraphSelTime } from "../../../datastore/emslistSlice.js";

let now = new Date();
const initial = {
  // min: +now - 480 * 60 * 1000,
  // max: +now,
  // start: +now - 60 * 30 * 1000,
  // end: +now - 60 * 15 * 1000,
  minRange: 5 * 1000 * 60,
};

const mapStateToProps = (state = {}) => {
  return { ...state };
};
// const dispatch = useDispatch();
export class PowerChart extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSetRange = this.handleSetRange.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  onRangeChange(params) {
    const { dispatch } = this.props;
    dispatch(
      setPwrGraphSelTime({
        start: params.start,
        end: params.end,
        selectedTime: null,
      })
    );
  }

  handleChange(e) {
    // this.setState({ [e.target.name]: e.target.value });
    const { dispatch } = this.props;
    dispatch(
      setPwrGraphSelTime({
        [e.target.name]: e.target.value,
        selectedTime: null,
      })
    );
  }

  handleButtonClick(time) {
    const { min, max } = this.props.emsPowerGraph.selectedTime;
    const { dispatch } = this.props;
    let aux = max - time;
    aux = aux < min ? min : aux;
    dispatch(
      setPwrGraphSelTime({
        end: max,
        start: aux,
        selectedTime: time,
      })
    );
  }

  handleSetRange() {
    // const { from, to } = this.state;
    // const { min, max } = this.props.emsPowerGraph;
    // // console.log("from:", from, "to", to, "min", min, "max", max);
    // const date = moment().format("YYYY-MM-DD");
    // const start = moment(date + " " + from);
    // const end = moment(date + " " + to);
    // if (!(start.isValid() && end.isValid())) {
    //   // this.setState({ error: "Invalid time" });
    //   return;
    // }
    // if (end.isAfter(moment(max)) || start.isBefore(moment(min))) {
    //   // this.setState({ error: "Range out of bounds" });
    //   return;
    // }
    // const lowerBound = moment(+start + initial.minRange);
    // if (lowerBound.isAfter(end)) {
    //   // this.setState({ error: "Final time too small" });
    //   return;
    // }
    // const upperBound = moment(+end - initial.minRange);
    // if (upperBound.isBefore(start)) {
    //   // this.setState({ error: "Initial time too big" });
    //   return;
    // }
    // this.setState({
    //   start,
    //   end,
    //   error: null,
    //   selectedTime: null,
    // });
  }

  handleClickOpen = (BatteryID) => {
    // this.setState({ dailogOpen: true });
    // this.setState({ emsDetailBatteryId: BatteryID });

    let res = this.checkGrid(BatteryID);
    if (res === true) {
      document.getElementById("gridConn").style.visibility = "hidden";
    } else {
      document.getElementById("gridConn").style.visibility = "visible";
    }
  };

  handleClose = () => {
    this.setState({ dailogOpen: false });
    this.setState({ emsDetailBatteryId: "" });
  };

  componentDidMount() {
    const self = this;
  }
  componentDidUpdate() {}

  render() {
    const { emsPowerArray, selectedTime } = this.props.emsPowerGraph;
    const { start, end, min, max } = selectedTime;
    const packet = this.props.eachEMSData;

    return (
      <div>
        {packet != {} && packet["PacketType"] == 1 ? (
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={6} md={8}>
              <div className="float-left">
                <Typography variant="h6" style={{ marginBottom: 4 }}>
                  Load Chart
                </Typography>
              </div>
              <div className="float-right">
                <Typography className="inline-form-label">Zoom</Typography>
                <ButtonGroup>
                  <Button
                    color="secondary"
                    size="sm"
                    className="range-btn"
                    onClick={() => {
                      this.handleButtonClick(15 * 60 * 1000);
                    }}
                    active={selectedTime === 15 * 60 * 1000}
                  >
                    15m
                  </Button>

                  <Button
                    color="secondary"
                    size="sm"
                    className="range-btn"
                    onClick={() => {
                      this.handleButtonClick(30 * 60 * 1000);
                    }}
                    active={selectedTime === 30 * 60 * 1000}
                  >
                    30m
                  </Button>
                  <Button
                    color="secondary"
                    size="sm"
                    className="range-btn"
                    onClick={() => {
                      this.handleButtonClick(60 * 60 * 1000);
                    }}
                    active={selectedTime === 60 * 60 * 1000}
                  >
                    1h
                  </Button>
                  <Button
                    color="secondary"
                    size="sm"
                    className="range-btn"
                    onClick={() => {
                      this.handleButtonClick(120 * 60 * 1000);
                    }}
                    active={selectedTime === 120 * 60 * 1000}
                  >
                    2h
                  </Button>
                  <Button
                    color="secondary"
                    size="sm"
                    className="range-btn"
                    onClick={() => {
                      this.handleButtonClick(Number.MAX_SAFE_INTEGER);
                    }}
                    active={selectedTime === Number.MAX_SAFE_INTEGER}
                  >
                    All
                  </Button>
                </ButtonGroup>
              </div>
            </Grid>
            <Grid item xs={6} md={8}>
              <Grid container direction="column">
                <Grid item>
                  <Box
                    sx={{
                      height: 400,
                      position: "relative",
                    }}
                  >
                    <GraphWrapper
                      theme="light"
                      start={start}
                      end={end}
                      data={emsPowerArray}
                      emsName={this.props.emsName}
                    />
                  </Box>
                </Grid>
                <Grid item>
                  <Slider
                    min={min}
                    max={max}
                    minRange={initial.minRange}
                    start={start}
                    end={end}
                    onRangeChange={this.onRangeChange.bind(this)}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <div>
            {emsPowerArray.length > 0 ? (
              <Grid container alignItems="center" spacing={2}>
                <Grid item xs={6} md={8}>
                  <div className="float-left">
                    <Typography variant="h6" style={{ marginBottom: 4 }}>
                      Load Chart
                    </Typography>
                  </div>
                  <div className="float-right">
                    <Typography className="inline-form-label">Zoom</Typography>
                    <ButtonGroup>
                      <Button
                        color="secondary"
                        size="sm"
                        className="range-btn"
                        onClick={() => {
                          this.handleButtonClick(15 * 60 * 1000);
                        }}
                        active={selectedTime === 15 * 60 * 1000}
                      >
                        15m
                      </Button>

                      <Button
                        color="secondary"
                        size="sm"
                        className="range-btn"
                        onClick={() => {
                          this.handleButtonClick(30 * 60 * 1000);
                        }}
                        active={selectedTime === 30 * 60 * 1000}
                      >
                        30m
                      </Button>
                      <Button
                        color="secondary"
                        size="sm"
                        className="range-btn"
                        onClick={() => {
                          this.handleButtonClick(60 * 60 * 1000);
                        }}
                        active={selectedTime === 60 * 60 * 1000}
                      >
                        1h
                      </Button>
                      <Button
                        color="secondary"
                        size="sm"
                        className="range-btn"
                        onClick={() => {
                          this.handleButtonClick(120 * 60 * 1000);
                        }}
                        active={selectedTime === 120 * 60 * 1000}
                      >
                        2h
                      </Button>
                      <Button
                        color="secondary"
                        size="sm"
                        className="range-btn"
                        onClick={() => {
                          this.handleButtonClick(Number.MAX_SAFE_INTEGER);
                        }}
                        active={selectedTime === Number.MAX_SAFE_INTEGER}
                      >
                        3h
                      </Button>
                    </ButtonGroup>
                  </div>
                </Grid>
                <Grid item xs={6} md={8}>
                  <Grid container direction="column">
                    <Grid item>
                      <Box
                        sx={{
                          height: 400,
                          position: "relative",
                        }}
                      >
                        <GraphWrapper
                          theme="light"
                          start={start}
                          end={end}
                          data={emsPowerArray}
                          emsName={this.props.emsName}
                        />
                      </Box>
                    </Grid>
                    <Grid item>
                      <Slider
                        min={min}
                        max={max}
                        minRange={initial.minRange}
                        start={start}
                        end={end}
                        onRangeChange={this.onRangeChange.bind(this)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              <div />
            )}
          </div>
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps)(PowerChart);
